// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/app.scss
// module id = 866
// module chunks = 0